import { format } from 'date-fns';
import type { Feature } from 'geojson';
import { TrafikenConfig } from '../../TrafikenConfig';
import { AjaxSource } from '../AjaxSource';
import type { AjaxSourceOptions } from '../Sources.types';

const defaultOptions = (apiPath: string) => ({
    id: `parking-gbg-${apiPath}`,
    url: `${TrafikenConfig.gbgParkings.serviceUrl}${apiPath}/${TrafikenConfig.gbgParkings.authKey}?format=json`,
});

interface ParkingGbg {
    currentParkingCost?: string;
    extraInfo?: string;
    freeSpaces?: number | null;
    freeSpacesDate: string;
    id: string;
    lat: number;
    long: number;
    maxParkingTime?: string;
    maxParkingTimeLimitation?: string;
    name: string;
    owner?: string;
    parkableLength?: number;
    parkingCharge?: string;
    parkingCost?: string;
    parkingSpaces?: number;
    parkingType: string;
    phoneParkingCode?: string;
    residentialParkingArea?: string;
    totalSpaces: number;
    updated?: Date;
    address: string;
    spaces: number;
}

export interface ParkingGbgProperties extends ParkingGbg {
    provider: string;
    iconId: number;
}

export class ParkingsGbgSource extends AjaxSource {
    _iconId: number;
    constructor(apiPath: string, iconId?: number, options?: AjaxSourceOptions) {
        super({ ...defaultOptions(apiPath), ...options });

        this._iconId = iconId;
    }

    parseData(parkings: ParkingGbg[]): Feature[] {
        return parkings.reduce((list, parking) => {
            if (!(parking.lat && parking.long)) {
                return list;
            }
            if (parking.freeSpacesDate && parking.freeSpacesDate.indexOf('Date') !== -1) {
                parking.freeSpacesDate = format(new Date(parseInt(parking.freeSpacesDate.replace(/(^.*\()|([+-].*$)/g, ''))), 'yyyy-MM-dd HH.mm');
            }
            return list.concat({
                id: parking.id,
                geometry: {
                    type: 'Point',
                    coordinates: [parking.long, parking.lat],
                },
                properties: {
                    provider: 'Göteborgs stad',
                    iconId: this._iconId,
                    ...parking,
                },
            });
        }, []);
    }
}
